<template>
    <div v-if="envLabel" class="env-banner" :style="bannerStyle">
        {{ envLabel }}
    </div>
</template>

<script>
const BANNER_HEIGHT_PX = 28;

const ENV_COLORS = {
    LOCAL: { bg: '#781010', text: '#ffffff' },
    DEV: { bg: '#388e3c', text: '#ffffff' },
    INT: { bg: '#7b1fa2', text: '#ffffff' },
    UAT: { bg: '#fbc02d', text: '#ffffff' },
    PPD: { bg: '#f57c00', text: '#000000' }
};

export default {
    name: 'EnvironmentBanner',
    computed: {
        envLabel() {
            const hostname = window.location.hostname;
            if (['localhost', '127.0.0.1'].includes(hostname)) return 'LOCAL';
            const match = hostname.match(/^passaccount-(\w+)\./);
            if (!match) return null; // PROD — pas de bandeau
            return match[1].toUpperCase();
        },
        bannerStyle() {
            const colors = ENV_COLORS[this.envLabel] || { bg: '#546e7a', text: '#ffffff' };
            return {
                backgroundColor: colors.bg,
                color: colors.text
            };
        }
    },
    mounted() {
        if (this.envLabel) {
            document.documentElement.style.setProperty('--env-banner-height', `${BANNER_HEIGHT_PX}px`);
        }
    },
    beforeDestroy() {
        document.documentElement.style.setProperty('--env-banner-height', '0px');
    }
};
</script>

<style>
.env-banner {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 200;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 2px;
    text-transform: uppercase;
}
</style>
